import axios from 'axios';
import Storage from '../helpers/storage';
import env from '../config/env';

const headers = {
  'Content-Type': 'application/json',
  'Accept-Language': 'pt-BR',
};

class Orders {
  get(hours = 72, cancelToken) {
    const merchant = Storage.getLocalStorage('merchant');
    const auth = Storage.getLocalStorage('auth');
    return axios.get(
      `${env.REACT_APP_MKTP_ENDPOINT}/unities/${merchant.idUnity}/orders?hoursBack=${hours}&style=extended`,
      {
        headers: {
          ...headers,
          authorization: `Bearer ${auth.accessToken}`,
        },
        cancelToken,
      }
    );
  }

  getByHoursBack(hours = 72) {
    const merchant = Storage.getLocalStorage('merchant');
    const auth = Storage.getLocalStorage('auth');
    return axios.get(
      `${env.REACT_APP_MKTP_ENDPOINT}/unities/${merchant.idUnity}/orders?hoursBack=${hours}&style=extended`,
      {
        headers: {
          ...headers,
          authorization: `Bearer ${auth.accessToken}`,
        },
      }
    );
  }

  getByStatus(status, hoursBack, idOrderType, cancelToken) {
    const merchant = Storage.getLocalStorage('merchant');
    const auth = Storage.getLocalStorage('auth');
    const url = `${env.REACT_APP_MKTP_ENDPOINT}/unities/${merchant.idUnity}/orders`;
    let params = {
      style: 'extended',
    };
    if (hoursBack !== 0) {
      params = {
        ...params,
        hoursBack,
      };
    }

    if (status !== 0) {
      params = {
        ...params,
        status,
      };
    }

    if (idOrderType !== 0) {
      params = {
        ...params,
        idOrderType,
      };
    }

    return axios.get(url, {
      headers: {
        ...headers,
        authorization: `Bearer ${auth.accessToken}`,
      },
      cancelToken,
      params,
    });
  }

  getById(id, cancelToken) {
    const auth = Storage.getLocalStorage('auth');
    return axios.get(`${env.REACT_APP_MKTP_ENDPOINT}/orders/${id}?style=extended`, {
      headers: {
        ...headers,
        authorization: `Bearer ${auth.accessToken}`,
      },
      cancelToken,
    });
  }

  update(id, data) {
    const auth = Storage.getLocalStorage('auth');
    return axios.put(`${env.REACT_APP_MKTP_ENDPOINT}/orders/${id}/status`, data, {
      headers: {
        ...headers,
        authorization: `Bearer ${auth.accessToken}`,
      },
    });
  }
}

export default new Orders();



// WEBPACK FOOTER //
// ./src/services/Orders.js